module.exports = __webpack_public_path__ + "static/media/nav-top.57e1d1f9.svg";